import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '@feathr/components';

interface IProps {
  affectedGoals?: number;
  className?: string;
  onRecalculate?: () => void;
}

function GroupEditWarning({
  affectedGoals,
  className,
  onRecalculate,
}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  const warnings: string[] = [t('Editing group filters only applies to new conversions.')];

  if (onRecalculate) {
    warnings.push(t('To apply changes to past data, select "Recalculate conversions".'));
  }

  if (affectedGoals !== undefined && affectedGoals > 0) {
    warnings.push(
      t('There are {{count}} goals using this group.', {
        count: affectedGoals,
      }),
    );
  }

  return (
    <Alert
      className={className}
      description={warnings}
      title={t(
        'Editing this group may affect the conversions of campaigns and flights that use it.',
      )}
      type={'warning'}
    >
      {onRecalculate && (
        <button onClick={onRecalculate} type={'button'}>
          {t('Recalculate conversions')}
        </button>
      )}
    </Alert>
  );
}

export default GroupEditWarning;
